import { toolVisit } from '../libs/Visitor'

export interface GenerateStickerResponse {
  status: string
  data: {
    url: string
    message: string
  }
}

export interface templatePayload {
  type: string
  template: string
}

export interface PropertyTemplatePayload extends templatePayload {
  title: string
  value: string
  quantity: number
}

export const tool = {
  generatePropertySticker(stickers: Array<PropertyTemplatePayload>) {
    return toolVisit<GenerateStickerResponse>({
      method: 'POST',
      url: 'generate-sticker',
      data: { name: 'rhitics-property', barcodes: stickers }
    })
  }
}
